import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  IconAlertTriangle,
  IconBell,
  IconCircleCheck,
  IconInfoCircle,
  IconX,
} from '@tabler/icons-react';
import { dismissCpanelToast, subscribeCpanelToasts } from '../../helpers/cpanelToast';

const THEME_CONFIG = {
  success: {
    icon: IconCircleCheck,
    iconClass: 'cpanel-toast__icon--success',
  },
  danger: {
    icon: IconAlertTriangle,
    iconClass: 'cpanel-toast__icon--danger',
  },
  info: {
    icon: IconInfoCircle,
    iconClass: 'cpanel-toast__icon--info',
  },
};

const CpanelToastContainer = () => {
  const navigate = useNavigate();
  const [toasts, setToasts] = useState([]);

  useEffect(() => subscribeCpanelToasts(setToasts), []);

  const handleOpen = (toast) => {
    if (toast.url) {
      navigate(toast.url);
    }
    dismissCpanelToast(toast.toastId);
  };

  if (!toasts.length) {
    return null;
  }

  return (
    <div className="cpanel-toast-container" aria-live="polite" aria-relevant="additions">
      {toasts.map((toast) => {
        const config = THEME_CONFIG[toast.theme] || THEME_CONFIG.success;
        const Icon = config.icon || IconBell;

        return (
          <div
            key={toast.toastId}
            className={`cpanel-toast cpanel-toast--${toast.theme}`}
            role="alert"
          >
            <span className={`cpanel-toast__icon ${config.iconClass}`} aria-hidden="true">
              <Icon size={18} stroke={1.75} />
            </span>
            <div className="cpanel-toast__body">
              {toast.url ? (
                <button type="button" className="cpanel-toast__link" onClick={() => handleOpen(toast)}>
                  <span className="cpanel-toast__title">{toast.title}</span>
                  {toast.message ? (
                    <span className="cpanel-toast__message">{toast.message}</span>
                  ) : null}
                  {toast.linkText ? (
                    <span className="cpanel-toast__action">{toast.linkText}</span>
                  ) : null}
                </button>
              ) : (
                <>
                  <span className="cpanel-toast__title">{toast.title}</span>
                  {toast.message ? (
                    <span className="cpanel-toast__message">{toast.message}</span>
                  ) : null}
                </>
              )}
            </div>
            <button
              type="button"
              className="cpanel-toast__close"
              aria-label="Tutup"
              onClick={() => dismissCpanelToast(toast.toastId)}
            >
              <IconX size={18} stroke={1.75} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default CpanelToastContainer;
